// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37UpR","importantInfo":"styles_importantInfo__110YH"};